import React, {
    useEffect,
    useState,
    useCallback
} from 'react'

import {
    AddNotes,
} from '../../../models/patients'

import {
    ErrorToast,
    SuccessToastMessage
} from '../../../components/loaders/toastMessage'

import {
    currentDate,
    initalModals,
    initalShowToastMessage
} from '../../../utils/constants/formInitialStates'

import {
    debounce,
    ViewBlisterPatientActiveMedication,
    usePDFJobStatus,
    blisterListHeading,
    weekday
} from './helper'

import { useBlisterSelectors } from '../../../services/selectors/blisterSelectors'
import {
    // fetchBlisterPackOnShelfPatientIDs,
    fetchBlisterPacksOnShelfList,
    fetchPatientActiveMedication,
    patientBlisterPackListFailure
} from '../../../services/actions/pharmacy/blisters/patientBlisterPackList'

import { CustomPagination } from '../../../components/pharmacy/dashboard/pagination'
import { initDropdowns } from 'flowbite'

import { fetchPatientDrugList } from '../../../services/actions/pharmacy/dispense/fetchAllDispenseListData'
import { BlisterPackDrugList } from '../../../models/blisters/patientPrescritiptionsDetails'

import { openPatientNoteModal } from '../../../assets/js/custome'
import { TextInput } from '../../../components/pharmacy/dispense/dispense'
import { loadXlsxModule } from '../../../utils/loadHeavyModules';

import { BlisterDropDown, BlisterVialsMedicationFacility, BlisterVialsMedicationRoute, Date } from '../../../components/pharmacy/form/form'
// import { ArchivedDelveriesDateRangePicker } from '../../../components/pharmacy/form/dateRangePicker'
import {
    BulkUpdateNOB,
    handleBlisterBulkDownloadPDF,
    handleBlisterBulkDownloadPDFJobStatus,
    handleDownloadBlisterSheet,
    UpdateBlisterOnShelfExportSheet,
    UpdateBlisterPAckOnShelf
} from '../../../services/actions/pharmacy/blisters/addBlisterPackData'

import { toast } from 'react-toastify'
import { ApiErrorMessage } from '../../../components/error/alertMessages'

import { AddPackonShelfNotes, UpdatedBlisterPackonShelfLogslist } from '../../../models/blisters/blisterPackOnShelf'
import { useCustomSelectors } from '../../../services/selectors/allSelectors'
import PatientSendTextModal from '../../../models/patients/PatientSendTextModal'

import UpdateBlisterlist from '../../../models/blisters/updateBlisterList'

import * as Common from '../../../components/common'
import * as Hooks from '../../../hooks'
import * as Icons from '../../../assets/svg/icons'

import * as Modals from '../../../assets/js/custome'
import * as useEffectHelper from '../../../utils/helper/useEffectsHelper'
import DeleteBlisterPackModal from '../../../models/blisters/deleteBlisterModal'
import { ablyConnectionManager } from '../../../utils/miscellaneous/ablyConnectionManager'

export const exportBlisterToExcel = async (data, fileName) => {
    const { utils, writeFile } = await loadXlsxModule();
    const formdattedData = data?.map(value => ({
        'PHN': value.phn,
        'PATIENT NAME': value.name,
        'ROUTE': value.blister_route,
        'FACILITY': value.facility,
        'NUMBER OF BLISTER PACK': value.no_of_blister_pack,
        'NOTES': value.notes,
    }))

    const worksheet = utils.json_to_sheet(formdattedData);

    worksheet['!cols'] = [
        { wch: 15 },
        { wch: 25 },
        { wch: 20 },
        { wch: 35 },
        { wch: 35 },
        { wch: 55 },
    ];
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // const now = new Date();
    // const time = now.toTimeString().split(' ')[0].replace(/:/g, ''); // Format: HHMMSS
    // const date = now.toISOString().split('T')[0].replace(/-/g, '');  // Format: YYYYMMDD
    // const dynamicFileName = `${fileName}-T${time}-${date}.xlsx`;


    writeFile(workbook, `${fileName}.xlsx`);
    // Write workbook as a Blob
    // const blob = write(workbook, { bookType: "xlsx", type: "blob" });
    // saveAs(blob, dynamicFileName); // Trigger download using FileSaver
    // writeFile(workbook, dynamicFileName);
};

const BlisterPacksOnShelf = () => {

    const location = Hooks.useCustomLocation()
    const navigate = Hooks.useCustomNavigate()
    const dispatch = Hooks.useCustomDispatch()

    const startDateRef = React.useRef()
    const endDateRef = React.useRef()

    const { patientBlisterPackListResponse, AddBlisterPackResponse } = useBlisterSelectors()
    const blisterList = patientBlisterPackListResponse?.data?.data
    const routeList = patientBlisterPackListResponse?.data?.data?.routes
    const facilityList = patientBlisterPackListResponse?.data?.data?.facility
    const dayList = patientBlisterPackListResponse?.data?.data?.day
    const shelfList = patientBlisterPackListResponse?.data?.data?.shelf

    const searchParams = new URLSearchParams();

    const initialPage = parseInt(new URLSearchParams(location.search).get('page')) || 1;

    const [pageNumber, setPageNumber] = useState(initialPage)
    const [showModal, setShowModal] = useState(initalModals)
    const [patientProfileData, setPatientProfileData] = useState(null)
    const [showToast, setShowToast] = useState(initalShowToastMessage)

    const [formData, setFormData] = useState({
        search: '',
        route: '',
        facility: '', day: '',
        weekday: '', startDate: '',
        endDate: '',
        no_of_blister_pack: '',
        shelfType: '',
        value: "",
        exclude_facility: '',
        pin: '',
        supervisor_pin: '',
        date: currentDate,
        qtyRemaining: ''
    })

    const [reset, setReset] = useState(false);
    const [showInput, setShowInput] = useState(false)

    // const [checkedRXNumbers, setCheckedRXNumbers] = useState([]);

    const [checkedItems, setCheckedItems] = useState(Array(blisterList?.data?.length).fill(false));
    const [allChecked, setAllChecked] = useState(false);
    const [blister_id, setBlister_id] = useState([]);
    const [filterParam, setFilterParam] = useState([])
    const [blisterPatientIDS, setBlisterPatientIDS] = useState([])
    const [patientId, setPatientId] = useState(null)
    const [expandedRows, setExpandedRows] = useState({})

    const { pharmacyId, adminModule } = useCustomSelectors()
    const [showPatientList, setShowPatientList] = useState(false)

    const activeMedicationDataResponse = patientBlisterPackListResponse?.activeMedicationData
    const activeMedication = activeMedicationDataResponse?.data?.data?.result

    // const patient_blister_id = patientBlisterPackListResponse?.data?.data?.patient_blister_id
    // const patient_blister_id = blisterPatientIDS

    useEffect(() => {
        if (initialPage) {
            setPageNumber(initialPage)
        }
    }, [initialPage])

    useEffect(() => {
        dispatch(patientBlisterPackListFailure(null, null))
    }, [])

    useEffect(() => {
        dispatch(fetchBlisterPacksOnShelfList('blister_packs_on_shelf_list', formData, pageNumber))
        return () => { }
    }, [])

    // 🔄 Shared logic for updating page URL and fetching data
    const updatePageAndFetchData = (page) => {
        setPageNumber(page);
        searchParams.set('page', page);
        const newUrl = `${location.pathname}?${searchParams.toString()}`;
        setPatientId(null);
        setShowPatientList(false);
        dispatch(fetchBlisterPacksOnShelfList('blister_packs_on_shelf_list', formData, page));
        navigate(newUrl);
    };

    const handleSearch = (event, value) => {
        updatePageAndFetchData(1);
    };

    const handlePagination = (event, value) => {
        updatePageAndFetchData(value);
    };

    useEffect(() => {
        initDropdowns()
    }, [blisterList?.data])

    const handleReset = () => {
        searchParams.delete('page');
        setReset(true)
        setShowPatientList(false)
        setPatientId(null)

        setFormData({
            ...formData,
            search: '',
            route: '',
            facility: '',
            day: '',
            weekday: '',
            startDate: '',
            endDate: '',
            value: "",
            exclude_facility: '',
            no_of_blister_pack: '',
            shelfType: '',
            date: currentDate,
            qtyRemaining: ''
        })

        setTimeout(() => {
            setReset(false)
        }, 500);

        const newUrl = `${location.pathname}?${searchParams.toString()}`;
        navigate(newUrl);
        setPageNumber(1)

        setCheckedItems([])
        // setCheckedRXNumbers([])
        setBlister_id([])
        setAllChecked(false)
        // fetchBlisterPackOnShelfPatientIDs(setBlisterPatientIDS)
        dispatch(fetchBlisterPacksOnShelfList('blister_packs_on_shelf_list', formData, pageNumber, 'reset'))
    }

    useEffectHelper.useArchivedDelveriesDateRangePickerEffect(formData, setFormData, startDateRef, endDateRef)

    useEffect(() => {
        if (blisterList?.data?.length) {
            const newCheckedItems = blisterList?.data?.map(item => blister_id.includes(item.id));
            setCheckedItems(newCheckedItems);
        }
    }, [blisterList, blister_id]);

    const handleHeaderCheckboxChange = (event) => {
        const checked = event.target.checked;
        setAllChecked(checked);
        setCheckedItems(Array(blisterList?.data?.length).fill(checked));

        if (checked) {
            const blisterIds = blisterList?.data?.map((value) => value.id);
            // const newBlisterIds = [...new Set([...patient_blister_id, ...blisterIds])];
            // console.log(patient_blister_id)
            // console.log(blisterIds)
            setBlister_id(blisterIds);
        } else {
            setBlister_id([]);
            // setCheckedRXNumbers([]);
        }
    };

    const handleCheckboxChange = (idx, id) => {
        const newCheckedItems = [...checkedItems];
        newCheckedItems[idx] = !newCheckedItems[idx];
        setCheckedItems(newCheckedItems);

        if (newCheckedItems[idx]) {
            const newBlisterIds = [...new Set([...blister_id, id])];
            setBlister_id(newBlisterIds);
        } else {
            const newBlisterIds = blister_id.filter(num => num !== id);
            setBlister_id(newBlisterIds);
        }
    }

    //Handle Input Debounce
    const debouncedDispatch = useCallback(
        debounce((formData, id, filterParam) => {
            dispatch(UpdateBlisterPAckOnShelf('update_blister_packs_on_shelf',
                formData, id,
                setShowModal,
                setShowToast,
                pageNumber,
                filterParam));
        }, 1000),
        []
    );

    const handleUpdateBlukBlisterPack = () => {
        const { pin, supervisor_pin } = formData

        if (!pin) {
            toast.error('Pin is required', { toastId: 'blister-pin-required' })
        } else if (!supervisor_pin) {
            toast.error('Supervisor Pin is required', { toastId: 'blister-supervisor-pin-required' })
        }
        else {
            dispatch(BulkUpdateNOB('update_bluk_number',
                formData,
                blister_id,
                setShowModal,
                setShowToast,
                pageNumber,
                setAllChecked,
                setBlister_id,
                setFormData
            ))
        }
    }

    const handleExportExcelSheet = () => {

        let requestData = {};

        if (blister_id && blister_id?.length > 0) {
            requestData.blister_ids = blister_id;
        }

        if (formData.route) requestData.route = formData.route;
        if (formData.search) requestData.search = formData.search;
        if (formData.day) requestData.rec_day = formData.day.match(/\d+/)[0];
        if (formData.weekday) requestData.rec_weekday = formData.weekday;
        if (formData.facility) requestData.facility = formData.facility;
        if (formData.startDate) requestData.from_date = formData.startDate;
        if (formData.endDate) requestData.to_date = formData.endDate;
        if (formData.shelfType) requestData.no_of_blister_pack = formData.shelfType;
        if (formData.exclude_facility) requestData.exclude_facility = formData.exclude_facility;

        dispatch(UpdateBlisterOnShelfExportSheet('excel_sheet', requestData))
    }



    //Show Active Medication
    const handleShowActiveMedication = (phn, id) => {
        setPatientId(id)
        setShowPatientList(true)

        const payloadData = {
            phn: phn,
            pharmacy_id: pharmacyId
        }
        if (phn) {
            dispatch(fetchPatientActiveMedication('blister-sheets', payloadData))
        }
    }


    const handleBulkDownload = () => {
        sessionStorage.setItem('job', JSON.stringify({ loading: true, data: null, error: null }));
        dispatch(handleBlisterBulkDownloadPDF('bulk-patient-blister-pdf', formData))
    }


    const { loading, data } = usePDFJobStatus();
    const pdfJobStatus = data?.job_status?.status;

    const [procesedFiles, setProcesedFiles] = useState(null)

    useEffect(() => {
        if (!pharmacyId) return;

        const channelName = `pharmacy-bulk-blister-sheet`;
        const channel = ablyConnectionManager.getChannel(channelName);
        if (!channel) return;

        const messageNotification = `download-blister-sheet-${pharmacyId}`;
        const subscriptionId = `${channelName}-${messageNotification}`;

        // Subscribe to messages
        const handleMessage = (message) => {
            // console.log('Received message:', message);
            if (message?.data?.id) {
                setProcesedFiles(message?.data)
                dispatch(handleBlisterBulkDownloadPDFJobStatus(message?.data?.id));
            }
        };

        ablyConnectionManager.subscribe(channelName, messageNotification, handleMessage, subscriptionId);

        return () => {
            ablyConnectionManager.unsubscribe(subscriptionId);
        };
    }, [pharmacyId, dispatch]);


    const handleDownloadAllFiles = async () => {
        const jobData = JSON.parse(sessionStorage.getItem('job'))?.data?.job_status;

        if (jobData && jobData.zip_name) {
            const zipFileUrl = jobData.zip_name;
            const link = document.createElement('a');
            link.href = zipFileUrl;
            link.setAttribute('download', 'bulk-download.zip');  // Force download with a custom name
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        };
    }

    const [noOfMedication, setNoOfMedication] = useState('')
    const [showNoOfMedication, setShowNoOfMedication] = useState(false)

    const handleSaveNoOfMedication = (phn, id, noOfMedication) => {
        setPatientId(id)
        if (id !== patientId) {
            setShowPatientList(false)
        }
        const requestData = {
            phn: phn,
            sheet_date: formData?.date,
            patient_id: id
        }

        if (noOfMedication) {
            requestData.no_of_medication_billed = noOfMedication
        }

        if (phn && formData?.date) {
            dispatch(handleDownloadBlisterSheet('packs-blister-sheets-pdf', requestData, null, formData, pageNumber, setNoOfMedication))
            // setNoOfMedication('')
        }
    }

    // const handleSaveNoOfMedication = () => {
    //     console.log('save')

    // }

    return (
        <React.Fragment>
            <Common.AppLayout>
                <div className="flex flex-wrap  gap-1 gap-y-2">
                    <div className='flex-0 lg:w-2/12 md:w-4/12 sm:w-12/12'>
                        <TextInput height='38px'
                            label='Search'
                            name='search'
                            formData={formData}
                            setFormData={setFormData} />
                    </div>

                    <div className=' hidden md:block' >
                        <BlisterDropDown formData={formData}
                            setFormData={setFormData}
                            name="route"
                            value={formData.route}
                            filterList={routeList}
                            reset={reset}
                            placeholder='Route'
                        />
                    </div>

                    <div className=' hidden md:block' >
                        <BlisterDropDown formData={formData}
                            setFormData={setFormData}
                            name='facility'
                            value={formData.facility}
                            filterList={facilityList}
                            reset={reset}
                            placeholder='Facility' />
                    </div>

                    <div className=' hidden md:block' >
                        <BlisterDropDown formData={formData}
                            setFormData={setFormData}
                            name='day'
                            value={formData.day}
                            filterList={dayList}
                            reset={reset}
                            placeholder='Day' />
                    </div>

                    <div className=' hidden md:block' >
                        <BlisterDropDown formData={formData}
                            setFormData={setFormData}
                            name='weekday'
                            value={formData.weekday}
                            filterList={weekday}
                            reset={reset}
                            placeholder='Week Day' />
                    </div>

                    <div className=' hidden md:block' >
                        <BlisterDropDown formData={formData}
                            setFormData={setFormData}
                            name='shelfType'
                            value={formData.shelfType}
                            filterList={shelfList}
                            reset={reset}
                            placeholder='Packs' />
                    </div>

                    <div className=' hidden md:block' >
                        <BlisterDropDown formData={formData}
                            setFormData={setFormData}
                            name='exclude_facility'
                            value={formData.exclude_facility}
                            filterList={facilityList}
                            reset={reset}
                            placeholder='Exclude Facility' />
                    </div>

                    <div className=' hidden md:block' style={{ width: '160px' }}>
                        <BlisterDropDown formData={formData}
                            setFormData={setFormData}
                            name='qtyRemaining'
                            value={formData.qtyRemaining}
                            filterList={['7', '14']}
                            reset={reset}
                            placeholder='Qty Remaining' />
                    </div>

                    {/* <div className='flex flex-0 lg:w-3/12 md:w-6/12 sm:w-8/12 w-full hidden lg:flex'
                                                style={{ gridTemplateColumns: '2fr 2fr 7px 2fr 2fr', width: '250px' }}>
                                                <ArchivedDelveriesDateRangePicker
                                                    startDateRef={startDateRef}
                                                    endDateRef={endDateRef}
                                                    formData={formData}
                                                    reset={reset}
                                                    setFormData={setFormData}
                                                    height='38px'
                                                />
                                            </div> */}

                    <div style={{ height: '38px' }}>
                        <button type="button" onClick={handleSearch}
                            className="flex  h-full  items-center w-fit justify-center text-white bg-blue-700 
                                                             font-medium rounded text-sm px-4">
                            Filter
                        </button>
                    </div>

                    <div style={{ height: '38px' }}>
                        <button type="button" style={{ backgroundColor: 'White' }} onClick={handleReset}
                            className="flex  h-full text-gray-900 items-center w-fit justify-center  bg-white 
                                                    border border-gray-300 font-medium rounded text-sm px-4 tex-gray-500">
                            Reset
                        </button>
                    </div>

                    <div style={{ height: '38px' }}>
                        <button type="button" onClick={handleExportExcelSheet}
                            className="flex gap-2 h-full items-center w-fit justify-center text-white bg-red-500 
                                                    font-medium rounded text-sm px-4 ">
                            {AddBlisterPackResponse.loading && AddBlisterPackResponse.type === 'excel_sheet' ? <Common.ProfilePicLoader color='white' /> : <><Icons.DownloadSheet /></>}
                        </button>
                    </div>

                    <div style={{ width: '140px' }}>
                        <Date
                            formData={formData}
                            setFormData={setFormData}
                            name='date'
                            label='PDF DATE'
                            className='rounded'
                            height='38px'
                            type='removeToday'
                        />
                    </div>

                    {
                        (formData.route || formData.facility || pdfJobStatus === 'pending' || pdfJobStatus === 'procecing' || loading) && formData.date && (
                            // <div className='flex gap-2' style={{ height: '38px' }}>
                            <>
                                {
                                    pdfJobStatus === 'completed' && procesedFiles?.processed_files > 0 ? null :
                                        <button style={{ height: '38px' }}
                                            type="button"
                                            onClick={handleBulkDownload}
                                            disabled={
                                                ((AddBlisterPackResponse.loading && AddBlisterPackResponse.type === 'bulk-patient-blister-pdf') ||
                                                    (loading || pdfJobStatus === 'pending' || pdfJobStatus === 'procecing'))
                                            }
                                            className="flex gap-2 h-full items-center w-fit justify-center text-white bg-red-500 border border-gray-300 
                                                                font-medium rounded text-sm px-4">
                                            {((AddBlisterPackResponse.loading && AddBlisterPackResponse.type === 'bulk-patient-blister-pdf') ||
                                                loading || pdfJobStatus === 'pending' || pdfJobStatus === 'procecing') ? (
                                                <Common.ProfilePicLoader color="white" />
                                            ) : 'Bulk Download PDF'}

                                        </button>
                                }

                                {
                                    (!procesedFiles && (AddBlisterPackResponse?.loading || pdfJobStatus === 'pending' || pdfJobStatus === 'procecing' || loading))
                                        ?
                                        <button style={{ height: '38px' }}
                                            type="button"
                                            className="flex gap-2 h-full items-center w-fit justify-center text-white bg-green-500 border border-gray-300 font-medium rounded text-sm px-4"
                                        >
                                            Mapping Data...
                                        </button>
                                        :
                                        procesedFiles?.processed_files > 0 && pdfJobStatus === 'completed' ?
                                            <button style={{ height: '38px' }}
                                                // disabled={procesedFiles?.processed_files === 0 && pdfJobStatus != 'completed'}
                                                type="button"
                                                onClick={handleDownloadAllFiles}
                                                className="flex gap-2 h-full items-center w-fit justify-center text-white bg-green-500 border border-gray-300 font-medium rounded text-sm px-4"
                                            >
                                                {procesedFiles?.processed_files} PDF's Ready to Download
                                            </button>
                                            :

                                            procesedFiles?.processed_files > 0 &&
                                            (
                                                <button style={{ height: '38px' }}
                                                    disabled={procesedFiles?.processed_files === 0 && pdfJobStatus != 'completed'}
                                                    type="button"
                                                    onClick={handleDownloadAllFiles}
                                                    className="flex gap-2 h-full items-center w-fit justify-center text-white bg-green-500 border border-gray-300 font-medium rounded text-sm px-4"
                                                >
                                                    {procesedFiles?.processed_files} PDF's Generated
                                                </button>
                                            )}
                            </>
                        )}

                </div>

                {blister_id?.length > 0 &&
                    <div className="flex flex-wrap lg:flex-nowrap gap-1 mt-2" style={{ height: '38px' }}>
                        <div className='w-fit'>
                            <button type="button" onClick={() => { return setFormData((prevStat) => ({ ...prevStat, value: '' })), setShowInput(!showInput) }}
                                className="flex  h-full items-center w-fit justify-center text-white bg-red-500 border border-gray-300 font-medium rounded text-sm px-4">
                                Bulk Update NOB
                            </button>
                        </div>
                        {showInput && <>
                            <div className='w-56'>
                                <TextInput label='Enter Value' name='value' formData={formData}
                                    textType='text' height='38px'
                                    classname='uppercase'
                                    setFormData={setFormData} />
                            </div>

                            <div className='w-fit'>
                                {
                                    formData.value && <div className='flex gap-1'>
                                        <div className='w-32'>
                                            <TextInput label='Enter PIN' name='pin' formData={formData}
                                                textType='number' height='38px'
                                                classname='uppercase'
                                                setFormData={setFormData} />
                                        </div>

                                        <div className='w-32'>
                                            <TextInput label='Supervisor PIN' name='supervisor_pin' formData={formData}
                                                textType='number' height='38px'
                                                classname='uppercase'
                                                setFormData={setFormData} />
                                        </div>

                                        <button type="button" style={{ height: '38px' }} onClick={handleUpdateBlukBlisterPack}
                                            className="flex  h-full  items-center w-fit justify-center text-white bg-blue-500 border border-gray-300 font-medium rounded text-sm px-4">
                                            {AddBlisterPackResponse.loading && AddBlisterPackResponse.type === 'update_bluk_number' ? 'Updating...' : 'Update'}
                                        </button>
                                    </div>
                                }
                            </div>
                        </>
                        }
                    </div>
                }

                {
                    patientBlisterPackListResponse?.loading && patientBlisterPackListResponse?.type === 'blister_packs_on_shelf_list' ?
                        <div className="flex justify-center items-center mt-60 mb-80">
                            <Common.LoadingView />
                        </div> :

                        patientBlisterPackListResponse?.error !== null && patientBlisterPackListResponse?.type === 'blister_packs_on_shelf_list' ?
                            <ApiErrorMessage /> :

                            blisterList?.data?.length === 0 && patientBlisterPackListResponse?.type === 'blister_packs_on_shelf_list' ?
                                <div className="bg-white rounded-md mt-4">
                                    <p className="text-gray-500">Blister Packs are not available.</p>
                                </div>

                                : patientBlisterPackListResponse?.type === 'blister_packs_on_shelf_list' ?
                                    <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-2 mt-4">
                                        <div className="border rounded relative overflow-auto min-h-screen scroll-box">
                                            <table className="bl_oatLogHistory w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 table-auto">
                                                <thead className=" uppercase dark:bg-gray-700 dark:text-gray-400 text-gray-900" style={{ borderBottom: '1px solid lightgray', background: '#f6f4f4' }}>
                                                    <tr>
                                                        {blisterListHeading?.map((header, index) => (
                                                            <th key={index} scope="col" className={header?.classNames?.join(" ")}>
                                                                {header.text === 'check' ?
                                                                    <input type="checkbox" className='w-5 h-5 text-blue-600 bg-white border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 
                                                                                            dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600 -mr-2'
                                                                        checked={allChecked}
                                                                        onChange={handleHeaderCheckboxChange} /> :
                                                                    <p className="rubik-500 fs-14">{header?.text}</p>}
                                                            </th>
                                                        ))}
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {
                                                        blisterList?.data?.map((value, idx) => {
                                                            const isLastIndex = idx === blisterList?.data?.length - 1;
                                                            const hasPrescriptions = value.latest_winrx_prescriptions && value.latest_winrx_prescriptions.length > 0;
                                                            return (<React.Fragment key={idx}>
                                                                <tr className={`${!hasPrescriptions && !isLastIndex ? 'border-b' : ''} relative`} >

                                                                    <td className="pl-3 py-3" >
                                                                        <input type="checkbox" className='w-5 h-5 text-blue-600 bg-white border-gray-300 rounded focus:ring-blue-500 
                                                                                                 focus:ring-2 mr-2'
                                                                            checked={checkedItems[idx]}
                                                                            onChange={() => handleCheckboxChange(idx, value.id)}
                                                                        />
                                                                    </td>

                                                                    <td className="py-3 text-black">
                                                                        {value.phn}
                                                                    </td>

                                                                    <td className={'py-3 btnnn text-black'}
                                                                        onClick={() => { return setPatientProfileData(value), Modals.handleShowModal(setShowModal, showModal, 'rxModal'), dispatch(fetchPatientDrugList(value.patient_id, 'patient_drug_list')) }}>
                                                                        <p className='rounded-lg no-wrap'>{value.name}</p>
                                                                    </td>

                                                                    <td className="px-3 !py-0 pb-0">
                                                                        {adminModule === 1 ?
                                                                            <input
                                                                                type="text"
                                                                                autoComplete="off"
                                                                                defaultValue={value.blister_route}
                                                                                onChange={(e) => {
                                                                                    const formData = { route: e.target.value };
                                                                                    debouncedDispatch(formData, value.id, filterParam);
                                                                                }}
                                                                                style={{
                                                                                    borderTop: 'none', borderLeft: 'none', borderRight: 'none',
                                                                                    width: '100px'
                                                                                }}
                                                                                className={`block pl-2 px-2.5 pb-0.5  w-full text-sm text-black  border-b border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer cursor-text bg-white `}
                                                                                placeholder=""
                                                                            />
                                                                            :
                                                                            <BlisterVialsMedicationRoute
                                                                                filterList={routeList}
                                                                                blisterRoute={value.blister_route}
                                                                                placeholder=''
                                                                                logId={value?.id}
                                                                                type='blister_route'
                                                                                pageNumber={pageNumber}
                                                                                setShowModal={setShowModal}
                                                                                setShowToast={setShowToast}
                                                                                pageType='pharmacy_blister_packs'
                                                                            />}

                                                                    </td>

                                                                    <td className="px-3 !py-0 pb-0">
                                                                        {adminModule === 1 ?
                                                                            <input
                                                                                type="text"
                                                                                autoComplete="off"
                                                                                defaultValue={value.facility}
                                                                                onChange={(e) => {
                                                                                    const formData = { facility: e.target.value };
                                                                                    debouncedDispatch(formData, value.id, filterParam);
                                                                                }}
                                                                                style={{ borderTop: 'none', borderLeft: 'none', borderRight: 'none', width: '100px' }}
                                                                                className={`block pl-2 px-2.5 pb-0.5  w-full text-sm text-black  border-b border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer cursor-text bg-white `}
                                                                                placeholder=""
                                                                            />
                                                                            :
                                                                            <BlisterVialsMedicationFacility
                                                                                filterList={facilityList}
                                                                                facility={value.facility}
                                                                                placeholder=''
                                                                                logId={value?.id}
                                                                                type='facility'
                                                                                pageNumber={pageNumber}
                                                                                setShowModal={setShowModal}
                                                                                setShowToast={setShowToast}
                                                                                pageType='pharmacy_blister_packs'
                                                                            />
                                                                        }
                                                                    </td>

                                                                    <td className="px-3 !py-0 pb-0">
                                                                        <input
                                                                            type="text"
                                                                            autoComplete="off"
                                                                            defaultValue={value.no_of_blister_pack}
                                                                            onChange={(e) => {
                                                                                const formData = { no_of_blister_pack: e.target.value };
                                                                                debouncedDispatch(formData, value.id, filterParam);
                                                                            }}
                                                                            style={{ borderTop: 'none', borderLeft: 'none', borderRight: 'none', width: '100px' }}
                                                                            className={`block pl-2 px-2.5 pb-0.5  w-full text-sm text-black  uppercase border-b border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer cursor-text bg-white `}
                                                                            placeholder=""
                                                                        />
                                                                    </td>

                                                                    <td className="px-3 !py-0 pb-0 w-[100px]">
                                                                        <div className='flex gap-2 items-end '>
                                                                            <textarea
                                                                                type="text"
                                                                                autoComplete="off"
                                                                                defaultValue={value.notes}
                                                                                ref={(el) => {
                                                                                    if (el) {
                                                                                        el.style.height = 'auto';
                                                                                        el.style.height = `${Math.min(el.scrollHeight, 150)}px`;
                                                                                    }
                                                                                }}
                                                                                onInput={(e) => {
                                                                                    e.target.style.height = 'auto';
                                                                                    e.target.style.height = `${e.target.scrollHeight}px`;
                                                                                    e.target.style.height = `${Math.min(e.target.scrollHeight, 150)}px`;
                                                                                }}
                                                                                onChange={(e) => {
                                                                                    const formData = { note: e.target.value };
                                                                                    debouncedDispatch(formData, value.id, filterParam);
                                                                                }}
                                                                                style={{ borderTop: 'none', borderLeft: 'none', borderRight: 'none', maxHeight: '150px', overflowY: 'auto' }}
                                                                                className={`block scroll-box pl-2 px-2.5 w-64 mb-2 text-sm text-black bg-transparent border-b border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer cursor-text bg-white `}
                                                                                placeholder=""
                                                                            />

                                                                            <div className='flex flex-col gap-y-1 mb-2'>
                                                                                <button
                                                                                    onClick={() => { return setPatientProfileData(value), Modals.handleShowModal(setShowModal, showModal, 'addPackOnShelfNotes') }}
                                                                                    className='px-2 py-1 text-white bg-green-700 w-fit h-fit rounded'>
                                                                                    +
                                                                                </button>

                                                                                {/* {value.extra_note?.length > 0 &&
                                                                                                            <button style={{ backgroundColor: '#060681' }}
                                                                                                                className='px-2 py-1 text-white rounded'>

                                                                                                                {value.extra_note?.length}
                                                                                                            </button>
                                                                                                        } */}
                                                                                {value.blisterpackNotes?.length > 0 &&
                                                                                    <button style={{ backgroundColor: '#060681' }}
                                                                                        className='px-2 py-1 text-white rounded'>

                                                                                        {value.blisterpackNotes?.length}
                                                                                    </button>
                                                                                }
                                                                            </div>
                                                                        </div>

                                                                    </td>



                                                                    <td className="px-3 !py-0 pb-0">
                                                                        <div className='flex gap-2 justify-end'>
                                                                            <button title='View'
                                                                                onClick={() => handleShowActiveMedication(value.phn, value.id)}
                                                                                className=''>
                                                                                <Icons.PDFViewIcon />
                                                                            </button>
                                                                            <div className='relative'>

                                                                                <button
                                                                                    disabled={AddBlisterPackResponse?.loading && AddBlisterPackResponse?.type === 'packs-blister-sheets-pdf'
                                                                                        && patientId === value?.id && noOfMedication
                                                                                    }
                                                                                    onMouseEnter={() => {
                                                                                        setShowNoOfMedication(true)
                                                                                        setPatientId(value?.id)
                                                                                        // setNoOfMedication('')

                                                                                    }}

                                                                                    onClick={() => {
                                                                                        handleSaveNoOfMedication(value?.phn, value?.id, noOfMedication)
                                                                                    }}
                                                                                    className='relative' title='Download PDF' >

                                                                                    {
                                                                                        AddBlisterPackResponse?.loading
                                                                                            && AddBlisterPackResponse?.type === 'packs-blister-sheets-pdf'
                                                                                            && patientId === value?.id && !noOfMedication
                                                                                            ? <Common.ProfilePicLoader color='black' /> :
                                                                                            value?.patientBlisterDownloadSheet != null ?
                                                                                                <Icons.DownLoadedPDFIcon /> :
                                                                                                <Icons.PDFIcon />
                                                                                    }

                                                                                </button>

                                                                                {
                                                                                    showNoOfMedication && patientId === value?.id &&
                                                                                    <div className="z-10 absolute right-0 top-full bg-blue-200 border shadow-md border-gray-100 px-3 py-2 translate-x-[35px] divide-y divide-gray-100 p-0"
                                                                                        onMouseLeave={() => {
                                                                                            setShowNoOfMedication(false)
                                                                                            setPatientId('')
                                                                                            // setNoOfMedication('')
                                                                                        }}
                                                                                    >
                                                                                        <div className='flex gap-0  items-center justify-center border bg-white border-gray-300'>
                                                                                            <input
                                                                                                onKeyPress={(e) => {
                                                                                                    if (e.key === 'Enter') {
                                                                                                        handleSaveNoOfMedication(value?.phn, value?.id, noOfMedication)
                                                                                                    }
                                                                                                }}
                                                                                                value={noOfMedication}
                                                                                                onChange={(e) => setNoOfMedication(e.target.value)}
                                                                                                type="number"
                                                                                                autoComplete="off"
                                                                                                className={`block px-2 py-1 w-[150px] text-sm text-black border-transparent  appearance-none focus:outline-none focus:ring-0 focus:border-transparent peer cursor-text`}
                                                                                                placeholder="Billed medication"
                                                                                            />

                                                                                            <button className='bg-blue-700 border-none text-white px-2 py-1 h-full'
                                                                                                disabled={!noOfMedication}
                                                                                                onClick={() => handleSaveNoOfMedication(value?.phn, value?.id, noOfMedication)}>
                                                                                                {
                                                                                                    AddBlisterPackResponse?.loading && AddBlisterPackResponse?.type === 'packs-blister-sheets-pdf'
                                                                                                        && patientId === value?.id && noOfMedication ? <Common.ProfilePicLoader color='white' /> : 'Save'
                                                                                                }
                                                                                            </button>
                                                                                        </div>
                                                                                    </div>
                                                                                }

                                                                            </div>


                                                                            <button id={`dropdownDefaultButton_${idx}`} data-dropdown-toggle={`dropdown_${idx}`} className="inline-flex  items-center  text-sm font-medium text-center focus:ring-4 focus:outline-none focus:ring-transparent" type="button">
                                                                                <Icons.EditIcon />
                                                                            </button>
                                                                        </div>

                                                                        <div id={`dropdown_${idx}`} className="z-10 relative border border-gray-100 hidden bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700">
                                                                            <ul className="py-2 text-sm text-gray-700 dark:text-gray-200" aria-labelledby={`dropdownDefaultButton_${idx}`}>

                                                                                {/* <li className='btnnn' onClick={() => { return setPatientProfileData(value), Modals.handleShowModal(setShowModal, showModal, 'updateBlisterlist') }}>
                                                                                                        <a className="flex items-center px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                                                                                                            <span className="pl-2">Updateed Logs</span>
                                                                                                        </a>
                                                                                                    </li> */}

                                                                                <li className='btnnn'
                                                                                    onClick={() => { return setPatientProfileData(value), Modals.handleShowModal(setShowModal, showModal, 'rxModal'), dispatch(fetchPatientDrugList(value.patient_id, 'patient_drug_list')) }}
                                                                                >
                                                                                    <a className="flex items-center px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                                                                                        <span className="pl-2">View Medicine</span></a>
                                                                                </li>

                                                                                <li onClick={() => { return setPatientProfileData(value) }} className='btnnn'>
                                                                                    <a onClick={() => openPatientNoteModal(setShowModal, showModal)} className="flex items-center px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">

                                                                                        <span className="pl-2">Add Pharmacy Note</span></a>
                                                                                </li>

                                                                                <li className='btnnn' onClick={() => { return setPatientProfileData(value), Modals.handleShowModal(setShowModal, showModal, 'updated_logs') }}>
                                                                                    <a className="flex items-center px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                                                                                        <span className="pl-2">Updated Logs</span>
                                                                                    </a>
                                                                                </li>

                                                                                <li onClick={() => { return setPatientProfileData(value), Modals.handleShowModal(setShowModal, showModal, 'deleteBlisterModal') }} className='btnnn'>
                                                                                    <a className="flex items-center px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                                                                                        <span className="pl-2">Delete</span></a>
                                                                                </li>

                                                                                <li onClick={() => {
                                                                                    setPatientProfileData(value);
                                                                                    Modals.handleShowModal(setShowModal, showModal, 'sendTextModal');

                                                                                }} className='btnnn' >
                                                                                    <a className="flex items-center px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                                                                                        <span className="pl-2">Send Text</span>
                                                                                    </a>
                                                                                </li>


                                                                            </ul>

                                                                        </div>
                                                                    </td>

                                                                    {
                                                                        value.updated_date_time && value.updated_by &&
                                                                        <span className='text-left text-black absolute bottom-1 xl:left-[4.2rem] left-10 italic' style={{ color: '#919191', fontSize: '9px' }}>
                                                                            Updated by {value.updated_by},{value.verfication_name && <> verified by {value.verfication_name} </>} on {value.updated_date_time}
                                                                        </span>
                                                                    }

                                                                </tr>

                                                                {value.latest_winrx_prescriptions && value.latest_winrx_prescriptions.length > 0 && (
                                                                    <tr style={{ borderBottom: idx !== blisterList?.data?.length - 1 ? '1px solid lightgray' : 'none' }}>
                                                                        <td colSpan={8} className="p-0 bg-gray-50">
                                                                            <div className="p-3">
                                                                                <button
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        setExpandedRows(prev => ({
                                                                                            ...prev,
                                                                                            [value.id]: !prev[value.id]
                                                                                        }));
                                                                                    }}
                                                                                    className="flex items-center gap-2 text-sm font-semibold text-gray-700 hover:text-gray-900 cursor-pointer"
                                                                                >
                                                                                    <span>RX Qty Remaining</span>
                                                                                    <svg className={`w-4 h-4 transition-transform ${expandedRows[value.id] ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                                                                    </svg>
                                                                                </button>
                                                                                {expandedRows[value.id] && (
                                                                                    <div className="mt-2 flex flex-wrap gap-2">
                                                                                        {value.latest_winrx_prescriptions.map((prescription, presIdx) => (
                                                                                            <div key={presIdx} className="flex flex-col bg-white rounded px-2.5 py-2 border border-gray-200 min-w-[180px]">
                                                                                                <span className="text-xs font-medium text-black mb-1">RX: {prescription.rxnumber}</span>
                                                                                                <div className="flex items-center gap-2">
                                                                                                    {prescription.qty_left && 
                                                                                                    <span className={`px-2 py-0.5 rounded-full text-xs font-medium text-white whitespace-nowrap ${parseFloat(prescription.qty_left) < 0 ? 'bg-orange-500' : 'bg-green-500'}`}>
                                                                                                        Qty: {prescription.qty_left}
                                                                                                    </span>
                                                                                                    }
                                                                                                    {/* <span className="text-xs text-gray-700 whitespace-nowrap">
                                                                                                        {PharmacyformattedDate(prescription.date_time)}
                                                                                                    </span> */}
                                                                                                </div>
                                                                                            </div>
                                                                                        ))}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                )}

                                                                {patientId === value?.id && showPatientList &&
                                                                    <tr className={`border-b border-gray-200`}>
                                                                        <td className='p-0' colSpan={8}>
                                                                            <ViewBlisterPatientActiveMedication
                                                                                activeMedication={activeMedication}
                                                                                type='blister-sheets'
                                                                                activeMedicationDataResponse={activeMedicationDataResponse} />
                                                                        </td>
                                                                    </tr>}
                                                            </React.Fragment>)
                                                        })}
                                                </tbody>
                                            </table>

                                            {patientBlisterPackListResponse?.error !== null ? null : <>
                                                {blisterList?.data?.length !== 0 && <>
                                                    {blisterList?.pagination?.last_page !== 1 &&
                                                        <div className="col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-12 flex lg:justify-end sm:justify-center md:justify-center justify-center mt-5">
                                                            <nav aria-label="Page navigation example">
                                                                <ul className="inline-flex -space-x-px text-base h-10">
                                                                    <CustomPagination
                                                                        count={blisterList?.pagination?.last_page}
                                                                        page={pageNumber}
                                                                        onChange={handlePagination}
                                                                    />
                                                                </ul>
                                                            </nav>
                                                        </div>
                                                    }
                                                </>}
                                            </>}
                                        </div>

                                    </div> : null}

            </Common.AppLayout>

            {showToast?.patientNoteToast && <SuccessToastMessage status='Note added sucessfully' />}
            {showToast.showToast && AddBlisterPackResponse?.type === 'update_blister_packs_on_shelf' && <SuccessToastMessage status='Updated sucessfully' />}
            {showToast.showToast && AddBlisterPackResponse?.type === 'delete_blister_pack' && <SuccessToastMessage status='Deleted sucessfully' />}
            {showToast.errorToast && AddBlisterPackResponse?.type === 'update_blister_packs_on_shelf' && <ErrorToast status={'Oops! Got an issue.please try to add again.'} />}
            {showToast.errorToast && AddBlisterPackResponse?.type === 'delete_blister_pack' && <ErrorToast status={'Oops! Got an issue.please try again.'} />}

            {showToast.showToast && AddBlisterPackResponse?.type === 'check_refills' && <SuccessToastMessage status='Updated sucessfully' />}
            {showToast.errorToast && AddBlisterPackResponse?.type === 'check_refills' && <ErrorToast status={'Oops! Got an issue.please try again.'} />}
            {showToast.showToast && AddBlisterPackResponse?.type === 'add_patient_note' && <SuccessToastMessage status='Note added sucessfully' />}
            {showToast.errorToast && AddBlisterPackResponse?.type === 'add_patient_note' && <SuccessToastMessage status='Oops! Got an issue while saving Note.please try again.' />}


            {showToast.showToast && AddBlisterPackResponse?.type === 'add_billing_note' && <SuccessToastMessage status='Note added sucessfully' />}
            {showToast.errorToast && AddBlisterPackResponse?.type === 'add_billing_note' && <SuccessToastMessage status='Oops! Got an issue while adding Billing Details.please try again.' />}

            <BlisterPackDrugList patientProfileData={patientProfileData}
                showModal={showModal}
                onClose={() => Modals.handleHideModal(setShowModal, showModal, 'rxModal')}
                setShowToast={setShowToast}
                setShowModal={setShowModal} />

            {
                showModal.patientNoteModal &&
                <AddNotes
                    showToast={showToast}
                    setShowToast={setShowToast}
                    setShowModal={setShowModal}
                    showModal={showModal}
                    patientProfileData={patientProfileData}
                    paginationNumber={pageNumber}
                />
            }

            {
                showModal.updateBlisterlist &&
                <UpdateBlisterlist
                    showToast={showToast}
                    setShowToast={setShowToast}
                    setShowModal={setShowModal}
                    showModal={showModal}
                    patientProfileData={patientProfileData}
                    paginationNumber={pageNumber}
                />
            }

            {
                showModal.updated_logs &&
                <UpdatedBlisterPackonShelfLogslist
                    setShowModal={setShowModal}
                    showModal={showModal}
                    patientProfileData={patientProfileData}
                />
            }

            {showModal.deleteBlisterModal &&
                <DeleteBlisterPackModal
                    formData={formData}
                    showToast={showToast}
                    setShowToast={setShowToast}
                    setShowModal={setShowModal}
                    showModal={showModal}
                    patientProfileData={patientProfileData}
                    paginationNumber={pageNumber}
                    text={'Are you sure you want to delete Blister Pack !'}
                />
            }

            {
                showModal.addPackOnShelfNotes &&
                <AddPackonShelfNotes
                    setShowModal={setShowModal}
                    showModal={showModal}
                    patientProfileData={patientProfileData}
                    pageNumber={pageNumber}
                    formData={formData}
                />
            }

            {showModal.sendTextModal && (
                <PatientSendTextModal
                    showModal={showModal}
                    setShowModal={setShowModal}
                    patientData={{
                        ...patientProfileData,
                        patient_name: patientProfileData?.name || patientProfileData?.patient_name
                    }}
                />
            )}

        </React.Fragment>
    )
}

export default BlisterPacksOnShelf
